export const parseMoneyValue = (value: unknown, decimals = 2): number => {
  if (value === null || value === undefined) {
    return 0
  }

  const numeric =
    parseFloat(
      String(value)
        .replace(',', '.')
        .replace(/[^0-9.]/g, ''),
    ) || 0

  return Number(numeric.toFixed(decimals))
}

const currencyFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  currencyDisplay: 'code',
})

export const formatMoneyValue = (value: number): string => {
  return currencyFormatter.format(value).replace(/\s*RUB/, '')
}
